// The hall photo for visualizers/warehouse.js: the MANIFEST only, here, so an
// entry point can withdraw the visualizer from the rotation when there is
// nothing to light (see orchestrator.js's disableVisualization, and gallery-
// assets.js for the same arrangement). The textures themselves are loaded by
// the visualizer when it is on screen - a 2560-wide photo and a 1024-wide
// depth map are too much GPU memory to hold for a composition that may never
// play.
const MANIFEST_URL = 'textures/warehouse.json';

let _promise = null;
let _manifest = null;

// Resolves to the manifest, or to null when the photo or its depth map is
// missing - said in the console, once.
export function preloadWarehouseScene() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('warehouse.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (m) {
      const photo = (m.variants || []).some(function (v) { return !v.role; });
      const depth = (m.variants || []).some(function (v) { return v.role === 'depth'; });
      if (!photo) throw new Error('warehouse.json has no photo variant');
      if (!depth) throw new Error('warehouse.json has no depth map (run tools/build-scenes.mjs with the social python)');
      _manifest = m;
      return m;
    })
    .catch(function (err) {
      console.error('[party-mode] warehouse scene unavailable, Warehouse will not be offered', err);
      _manifest = null;
      return null;
    });
  return _promise;
}

export function getWarehouseScene() {
  return _manifest;
}
